import { apiRequest } from "./client";

/** Lead-source integrations center (Sprint 15 QA). */

export const integrationsApi = {
  async getIntegrations() {
    return apiRequest("/api/org/integrations");
  },

  async regenerateLeadForm() {
    return apiRequest("/api/org/integrations/lead-form/regenerate", {
      method: "POST",
    });
  },

  async testWebsiteLead() {
    return apiRequest("/api/org/integrations/lead-form/test", {
      method: "POST",
    });
  },

  async mockIndiaMart() {
    return apiRequest("/api/integrations/indiamart/mock-push", {
      method: "POST",
    });
  },
};